module.exports = __webpack_public_path__ + "static/media/Hotel-Pfisl.0eb99b5e.jpg";